import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cfab3286"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "slideup" }
const _hoisted_2 = { class: "ui-ticket-slideup-header header" }
const _hoisted_3 = { class: "ui-ticket-slideup-main chat tech-flex" }
const _hoisted_4 = { class: "main" }
const _hoisted_5 = { class: "ui-ticket-slideup-drawer drawer" }

import TicketIm from '@/components/Workspaces/tickets/_spec/TicketIm.vue'
import TextEditor from '@/components/tech/TextEditor.vue'
import { IFileStorage } from '@/io/storages';
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { TicketAccessLevel } from '@/controllers/workspaces/user.controller.workspace';
import { TicketItemModel } from '@/app.context/workspace/tickets/_spec/Ticket.Item.Model';
import setup, { setupEscapeHook } from '@/controllers/workspaces/tickets/_spec/ticket.controller.chat'
import { stateObject, descriptionSubmit } from './ticket.controller.model';
import TicketDescription from '@/components/Workspaces/tickets/_spec/TicketDescription.vue'
import TicketFiles from '@/components/Workspaces/tickets/_spec/TicketFiles.vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'TicketSlideUp',
  props: {
    model: {},
    files: {},
    level: {}
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props

//const state = stateObject(props.model)

const emit = __emit

const im = ref<InstanceType<typeof TicketIm> | null>(null)

const f = setup(im, props)

//let u:()=>void = ()=>{console.log('fake esc')} //this is trick to subscribe/unsubscribe escape button hanlder


setupEscapeHook(() => emit('close'))

onMounted(() => {



    const element = document.getElementById('slideup') as HTMLElement

    if (element) {


        const rectangle = element.getBoundingClientRect()

        const b = rectangle.bottom + 200 //adjusment of size html min-heigh of ProseMirror css style
        const h = rectangle.height

        // console.log(`Bottom of slideup on mount:${b}`)
        // console.log(`Rect h: ${rectangle.height}`)
        // console.log(`Scroll top: ${window.scrollY}`)


        //const a = window.scrollY + window.innerHeight
        const a = window.innerHeight

        //console.log(`A: ${a}`)

        const offset = b - a


        //console.log(`Scroll down: ${offset}`)

        if (offset > 0) window.scrollBy(0, offset)

        //element.scrollTop = offset
    }


})

//onBeforeUnmount(u)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, "Close")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(TicketDescription, {
          id: "ui-ticket-slideup-main-description",
          model: props.model
        }, null, 8, ["model"]),
        _createVNode(TicketIm, {
          ref_key: "im",
          ref: im,
          class: "ui-ticket-slideup-main-chat",
          messages: _ctx.model.messages,
          onMessage: _unref(f).message,
          onFiles: _unref(f).files,
          height: 0
        }, null, 8, ["messages", "onMessage", "onFiles"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(TicketFiles, {
          model: _ctx.model.pack,
          ticket: _ctx.model.ticket,
          storage: _ctx.model.ticket!.workspace.storage,
          files: props.files
        }, null, 8, ["model", "ticket", "storage", "files"])
      ])
    ])
  ]))
}
}

})